import router from "../index";

export default function guest({next, store}) {
    if (store.getters.auth) {
        let user = store.getters.getUser;
        if (user.role === 'admin' || user.role === 'root') {
            return next({
                name: 'SuperAdmin'
            })
        } else if (user.role === 'member') {
            return next({
                name: "MemberHome"
            })
        }
    }

    return next()
}
